// IL MURO DELL'ACCOUNT (2026-09-13).
//
// Ci sono due rifiuti che non riguardano UN file: riguardano l'account. Spazio
// finito e numero massimo di file. Mostrarli come una riga rossa in mezzo alle
// altre e' fuorviante, perche' suggerisce che sia andato storto quel file —
// mentre in realta' non ne passa piu' nessuno, e i file in coda dietro non ci
// proveranno nemmeno.
//
// Percio' fermano la coda e aprono questo riquadro, con i numeri veri mandati
// dal server: 50 su 50, 1 GB di 1 GB. Non "quasi pieno", non "circa": i
// numeri che hanno causato il rifiuto.
//
// DENTRO L'APP NON C'E' IL TASTO. Le regole di Google non ammettono, dentro
// un'app, un percorso che porti a pagare fuori dal loro sistema — nemmeno un
// collegamento. Resta la frase, come testo, che dice dove andare. Sul telefono
// nel BROWSER il tasto invece c'e': li' quella regola non esiste. La
// distinzione e' Capacitor.isNativePlatform(), non la larghezza dello schermo.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Capacitor } from '@capacitor/core';
import './AvvisoAccount.css';

export default function AvvisoAccount({ motivo, onChiudi, onVediPiani }) {
  const { t } = useTranslation('vault');
  if (!motivo) return null;

  const dentroApp = Capacitor.isNativePlatform();

  // Dentro l'app le frasi sono quelle della notifica, parola per parola:
  // chi tocca la notifica deve ritrovare nel riquadro cio' che ha letto.
  const titolo = motivo.codice === 'FILE_LIMIT'
    ? (dentroApp ? t('muro_file_app', { massimo: motivo.maxFiles })
                 : t('muro_file', { usati: motivo.fileCount, massimo: motivo.maxFiles }))
    : motivo.codice === 'QUOTA_EXCEEDED'
      ? (dentroApp ? t('muro_spazio_app', { totale: motivo.totale })
                   : t('muro_spazio', { usato: motivo.usato, totale: motivo.totale }))
      : t('muro_generico');

  return (
    <div className="aa-fondo" role="dialog" aria-modal="true" onClick={onChiudi}>
      <div className="aa-riquadro" onClick={(e) => e.stopPropagation()}>
        <p className="aa-titolo">{titolo}</p>
        {motivo.nonCaricati > 0 && (
          <p className="aa-sotto">{t('muro_non_caricati', { count: motivo.nonCaricati })}</p>
        )}
        <div className="aa-fondo-riga">
          {dentroApp
            ? <span className="aa-dove">{t('spazio_esaurito_app')}</span>
            : <button type="button" className="aa-piani" onClick={onVediPiani}>{t('spazio_vedi_piani')}</button>}
          <button type="button" className="aa-chiudi" onClick={onChiudi}>{t('muro_chiudi')}</button>
        </div>
      </div>
    </div>
  );
}
